import { render, staticRenderFns } from "./AddProducts.vue?vue&type=template&id=ffcace86&"
import script from "./AddProducts.vue?vue&type=script&lang=js&"
export * from "./AddProducts.vue?vue&type=script&lang=js&"
import style0 from "./AddProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports